export default "__VITE_ASSET__DS$v7ifA__"